export var GooglePayCheckoutStatus;
(function (GooglePayCheckoutStatus) {
    /** Represents an estimated price (meaning it's not final and could change) and the default checkout option. The confirmation button will display "Pay". */
    GooglePayCheckoutStatus["estimatedDefault"] = "EstimatedDefault";
    /** Represents the final price of the transaction and the default checkout option. The confirmation button will display "Pay". */
    GooglePayCheckoutStatus["finalDefault"] = "FinalDefault";
    /** Represents the final price of the transaction and the immediate checkout option. The confirmation button will display "Pay now". */
    GooglePayCheckoutStatus["finalImmediatePurchase"] = "FinalImmediatePurchase";
})(GooglePayCheckoutStatus || (GooglePayCheckoutStatus = {}));
export var LineItemType;
(function (LineItemType) {
    /** Represents a subtotal line item in a digital wallet transaction */
    LineItemType["subtotal"] = "Subtotal";
    /** Represents a line item in a digital wallet transaction */
    LineItemType["lineItem"] = "LineItem";
    /** Represents a tax line item in a digital wallet transaction */
    LineItemType["tax"] = "Tax";
})(LineItemType || (LineItemType = {}));
export var LineItemStatus;
(function (LineItemStatus) {
    /** Indicates that the price is final and has no variance */
    LineItemStatus["final"] = "Final";
    /** Indicates that the price is pending and may change. On iOS this will cause the amount to appear as an elipsis ("...") */
    LineItemStatus["pending"] = "Pending";
})(LineItemStatus || (LineItemStatus = {}));
export var CardType;
(function (CardType) {
    /** Visa credit card type. Pass the string value of this into the Olo Ordering API when submitting orders */
    CardType["visa"] = "Visa";
    /** American Express credit card type. Pass the string value of this into the Olo Ordering API when submitting orders */
    CardType["amex"] = "Amex";
    /** Mastercard credit card type. Pass the string value of this into the Olo Ordering API when submitting orders */
    CardType["mastercard"] = "Mastercard";
    /** Discover credit card type. Pass the string value of this into the Olo Ordering API when submitting orders */
    CardType["discover"] = "Discover";
    /** Unsupported credit card type. Passing this to the Olo Ordering API will result in an error */
    CardType["unsupported"] = "Unsupported";
    /** Unknown credit card type. Passing this to the Olo Ordering API will result in an error */
    CardType["unknown"] = "Unknown";
})(CardType || (CardType = {}));
/** Specific kinds of Google Pay Errors */
export var GooglePayErrorType;
(function (GooglePayErrorType) {
    /** Google Pay didn't succeed due to a network error */
    GooglePayErrorType["networkError"] = "NetworkError";
    /** Google Pay didn't succeed due to developer error */
    GooglePayErrorType["developerError"] = "DeveloperError";
    /** Google Pay didn't succeed due to an internal error */
    GooglePayErrorType["internalError"] = "InternalError";
})(GooglePayErrorType || (GooglePayErrorType = {}));
//SEE DOCUMENTATION IN README.MD
export var PromiseRejectionCode;
(function (PromiseRejectionCode) {
    PromiseRejectionCode["invalidParameter"] = "InvalidParameter";
    PromiseRejectionCode["missingParameter"] = "MissingParameter";
    PromiseRejectionCode["applePayUnsupported"] = "ApplePayUnsupported";
    PromiseRejectionCode["sdkUninitialized"] = "SdkUninitialized";
    PromiseRejectionCode["applePayError"] = "ApplePayError";
    PromiseRejectionCode["applePayTimeoutError"] = "ApplePayTimeoutError";
    PromiseRejectionCode["googlePayNetworkError"] = "GooglePayNetworkError";
    PromiseRejectionCode["googlePayDeveloperError"] = "GooglePayDeveloperError";
    PromiseRejectionCode["googlePayInternalError"] = "GooglePayInternalError";
    PromiseRejectionCode["googlePayInvalidSetup"] = "GooglePayInvalidSetup";
    PromiseRejectionCode["digitalWalletUninitialized"] = "DigitalWalletUninitialized";
    PromiseRejectionCode["digitalWalletNotReady"] = "DigitalWalletNotReady";
    PromiseRejectionCode["emptyCompanyLabel"] = "EmptyCompanyLabel";
    PromiseRejectionCode["emptyMerchantId"] = "EmptyMerchantId";
    PromiseRejectionCode["invalidCountryCode"] = "InvalidCountryCode";
    PromiseRejectionCode["lineItemsTotalMismatch"] = "LineItemsTotalMismatch";
    PromiseRejectionCode["unexpectedError"] = "UnexpectedError";
    PromiseRejectionCode["uninmplemented"] = "UNIMPLEMENTED";
    PromiseRejectionCode["generalError"] = "generalError";
})(PromiseRejectionCode || (PromiseRejectionCode = {}));
//SEE DOCUMENTATION IN README.MD
export const DigitalWalletReadyEvent = 'digitalWalletReadyEvent';
//# sourceMappingURL=definitions.js.map